import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'


const initialState = {
    permissions: [],
    // rôle par boutique : permissions ajoutées dans chaque boutique où l'utilisateur a un rôle
    shopPermissions: {},
    // boutique visée par l'écran courant (id, 'active' en caisse, null sur les écrans société)
    contextShopId: null,
    permissionLabels: {}
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
